import { LoadingCircleModule } from './../../../shared/component/common/loading-circle/loading-circle.module';
import { RetryModule } from './../../../shared/component/common/retry/retry.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { DocumentTypeComponent } from './document-type.component';
import { HeaderModule } from '../../../shared/component/common/header/header.module';
import { ButtonModule } from '../../../shared/component/common/button/button.module';
import { LabelModule } from '../../../shared/component/common/label/label.module';
import { RadioModule } from '../../../shared/component/common/radio/radio.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HeaderModule,
    ButtonModule,
    LabelModule,
    RadioModule,
    RetryModule,
    LoadingCircleModule
  ],
  declarations: [DocumentTypeComponent]
})
export class DocumentTypeComponentModule {}
